import { Bot, Wrench, Mail } from "lucide-react";
import BotRunnerGame from "../components/BotRunnerGame";

export default function MaintenancePage() {
  return (
    <div
      className="min-h-screen flex flex-col items-center justify-center px-4 sm:px-6 lg:px-8 py-10 relative overflow-hidden"
      style={{
        background:
          "linear-gradient(135deg, #f8fafc 0%, #eef2ff 50%, #ede9fe 100%)",
      }}
    >
      {/* Decorative floating orbs */}
      <div
        aria-hidden="true"
        className="absolute -top-24 -left-24 w-80 h-80 rounded-full blur-3xl opacity-30"
        style={{
          background:
            "radial-gradient(circle, #c7d2fe 0%, transparent 70%)",
        }}
      />
      <div
        aria-hidden="true"
        className="absolute -bottom-24 -right-20 w-72 h-72 rounded-full blur-3xl opacity-30"
        style={{
          background:
            "radial-gradient(circle, #ddd6fe 0%, transparent 70%)",
        }}
      />

      <div className="relative z-10 w-full max-w-3xl text-center mb-8">
        {/* Bot badge with bouncing wrench overlay */}
        <div className="inline-flex items-center justify-center relative mb-6">
          <div
            className="w-20 h-20 rounded-3xl flex items-center justify-center shadow-lg"
            style={{
              background:
                "linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%)",
            }}
          >
            <Bot className="w-10 h-10 text-white" />
          </div>
          <div
            className="absolute -bottom-2 -right-2 w-9 h-9 rounded-2xl bg-white shadow-md flex items-center justify-center animate-bounce"
            style={{ animationDuration: "1.6s" }}
          >
            <Wrench className="w-5 h-5 text-indigo-600" />
          </div>
        </div>

        <h1 className="text-2xl sm:text-3xl md:text-4xl font-bold text-slate-800 mb-3">
          Botibonga Studio is undergoing scheduled maintenance
        </h1>
        <p className="text-sm sm:text-base text-slate-600 max-w-xl mx-auto mb-4 leading-relaxed">
          We're tuning a few things behind the scenes. Your agents and data
          are safe. The studio will be back online shortly.
        </p>
        <p className="text-xs sm:text-sm text-slate-500 mb-2">
          While you wait, give the bot a hand dodging spikes.
        </p>
      </div>

      <div className="relative z-10 w-full">
        <BotRunnerGame />
      </div>

      <div className="relative z-10 mt-8 text-center">
        <p className="text-xs text-slate-500 mb-2">
          Need to reach us? Drop a line and we'll respond as soon as we're back.
        </p>
        <a
          href="mailto:sales@botibonga.com"
          className="inline-flex items-center gap-2 text-sm font-medium text-indigo-600 hover:text-indigo-700 transition-colors"
        >
          <Mail className="w-4 h-4" />
          sales@botibonga.com
        </a>
      </div>
    </div>
  );
}
